import { useQuery } from 'react-query';
import { BulkPdfExportPassword } from '@oh-vcp/components-common';
import { apiGet } from './apiService';

const fetchBulkPdfPassword = async (
  delegatorId: string | undefined
): Promise<BulkPdfExportPassword> => {
  let url = `cases/export/pdf/bulk/password`;
  if (delegatorId && delegatorId !== '0') {
    url += `?delegatorId=${delegatorId}`;
  }
  return apiGet(url);
};

const useGetBulkPdfPassword = (delegatorId: string | undefined) => {
  return useQuery({
    queryFn: () => fetchBulkPdfPassword(delegatorId),
    queryKey: ['fetchBulkPdfPassword', delegatorId],
    enabled: false
  });
};

export default useGetBulkPdfPassword;
